import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { AppShell } from './layouts/AppShell'
import { BatchDetail } from './pages/BatchDetail'
import { BatchList } from './pages/BatchList'
import { Costs } from './pages/Costs'
import { DailyEntry } from './pages/DailyEntry'
import { Dashboard } from './pages/Dashboard'
import { Sales } from './pages/Sales'
import { Settings } from './pages/Settings'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The farm enters data once a day on one laptop. Aggressive refetching
      // buys nothing here and costs Supabase free-tier request budget (§12).
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'entry', element: <DailyEntry /> },
      { path: 'batches', element: <BatchList /> },
      { path: 'batches/:id', element: <BatchDetail /> },
      { path: 'costs', element: <Costs /> },
      { path: 'sales', element: <Sales /> },
      { path: 'settings', element: <Settings /> },
    ],
  },
])

const container = document.getElementById('root')
if (!container) throw new Error('No #root element in index.html')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
